import { getDocs, collection } from 'firebase/firestore'
import { database } from '../firebase'
import type { PartCategory } from '@/types'

export const getPartCategories = async (): Promise<PartCategory[]> => {
  try {
    const coll = collection(database, 'part_categories')
    const snapshot = await getDocs(coll)
    return snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    })) as PartCategory[]
  } catch (error) {
    console.error('Error al obtener categorías de repuestos:', error)
    return []
  }
}
